import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {DIALOG_CONFIG} from 'ac-infra';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'syslog-dialog',
  templateUrl: './syslog-dialog.component.html',
  styleUrls: ['./syslog-dialog.component.scss']
})
export class SyslogDialogComponent implements OnInit, AfterViewInit {

  data;
  protocolOptions = ['UDP', 'TCP'];
  debugLevelOptions = ['TRACE', 'DEBUG', 'INFO', 'WARN', 'ERROR'];

  @ViewChild('mapForm') mapForm: NgForm ;
  formStatus;
  conf;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) {
    this.data = dialogConfig.dialogData;
    this.conf = dialogConfig;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.mapForm.form.statusChanges.subscribe(() => {
      this.conf.submitButtonDisabled = !this.mapForm.form.valid;
    });
  }

}
